import { useQuery } from '@tanstack/react-query'

import {
  getAllBookingProductsAvailability,
  type GetAllBookingProductsAvailabilityOptions,
} from '@flecto/api/saas'
import {
  type CoreProductAvailabilityResponseList,
  type ParameterID,
} from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = GetAllBookingProductsAvailabilityOptions & {
  bookingId?: ParameterID
}

export function useQueryGetAllBookingProductsAvailability({
  bookingId,
  ...payload
}: QueryPayload) {
  const initialData: CoreProductAvailabilityResponseList = {
    product_availability: [],
    total_suggested_booking_cost_cents: 0,
    total_suggested_booking_cost_with_vat_cents: 0,
    search_id: 0,
    query: '',
    total_count: 0,
    current_count: 0,
    offset: 0,
    order: '',
    sort: '',
    limit: 0,
  }

  return useQuery({
    initialData,
    queryKey: ['QueryGetAllBookingProductsAvailability', Number(bookingId)],
    queryFn: async () =>
      await getAllBookingProductsAvailability(bookingId ?? '', payload),
    refetchOnWindowFocus: false,
    enabled: isValidParameterID(bookingId),
  })
}
